import type { GenerationRequestSummaryRead } from '../../types/api';
import { PostTile } from '../history/PostTile';
import { PanelLink } from './PanelLink';

interface RecentPostsProps {
  businessId: string;
  requests: readonly GenerationRequestSummaryRead[];
  isLoading: boolean;
  error: string | null;
  onRetry: () => void;
}

/**
 * The last six runs as pictures — the product makes images, so Home shows
 * them. The same tile History uses, in its compact form.
 */
export function RecentPosts({ businessId, requests, isLoading, error, onRetry }: RecentPostsProps) {
  return (
    <section className="home-panel" aria-labelledby="recent-posts-title">
      <div className="home-panel__head">
        <h2 className="home-panel__title" id="recent-posts-title">
          Recent posts
        </h2>
        <PanelLink to="/history">View all</PanelLink>
      </div>

      {isLoading ? (
        <p className="kb-section__status" role="status">
          Loading your posts
        </p>
      ) : error ? (
        <p className="home-panel__error">
          <span role="alert">{error}</span>{' '}
          <button className="link-button" type="button" onClick={onRetry}>
            Try again
          </button>
        </p>
      ) : requests.length === 0 ? (
        <p className="home-panel__empty">No posts yet. Start one above.</p>
      ) : (
        <ul className="post-grid post-grid--home">
          {requests.map((request) => (
            <PostTile
              key={request.id}
              businessId={businessId}
              request={request}
              variant="compact"
            />
          ))}
        </ul>
      )}
    </section>
  );
}
